import * as ComLink from 'comlink';
// eslint-disable-next-line import/default
import LayoutWorker from './layout.worker';

import {
  CUSTOM_CHART_TYPE,
  INTERNAL_CHART_TYPES,
  BATCH_CHART_CONFIG,
  BUILT_IN_CHART_TYPES,
  DEFAULT_SECTION_NAME,
  MEDIA_SECTION_NAME,
  TABLES_SECTION_NAME,
  CURVES_SECTION_NAME
} from '@experiment-management-shared/constants';

const worker = LayoutWorker();
const WrappedWorker = ComLink.wrap(worker);

WrappedWorker.init({
  BATCH_CHART_CONFIG,
  BUILT_IN_CHART_TYPES,
  CUSTOM_CHART_TYPE,
  INTERNAL_CHART_TYPES,
  DEFAULT_SECTION_NAME,
  MEDIA_SECTION_NAME,
  TABLES_SECTION_NAME,
  CURVES_SECTION_NAME
});

export default WrappedWorker;
